import { inject } from '@angular/core';
import { Router } from '@angular/router';

import { GetDecodedToken } from 'libs/core/src/lib/utils/token-decode';
import { SystemUserRole } from '@inshuwa-client/models';
import { NzNotificationService } from 'ng-zorro-antd/notification';

export const loginGuard = () => {
  const notification = inject(NzNotificationService);
  const decoded = GetDecodedToken();

  if (!decoded) {
    inject(Router).navigate(['/'], { replaceUrl: true });
    return false;
  }

  const { role } = decoded;

  if (
    role.toLowerCase() !== SystemUserRole.InsurerRepresentative.toLowerCase()
  ) {
    notification.error('Error', 'You are not authorized to access this route', {
      nzDuration: 0,
    });
    return false;
  }
  return true;
};
